import {
  Directive,
  AfterViewChecked,
  ElementRef,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[cignaAriaHiddenLinks]',
})
export class AriaHiddenLinksDirective implements AfterViewChecked {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewChecked(): void {
    const anchors: Array<HTMLAnchorElement | undefined> =
      this.elementRef.nativeElement.querySelectorAll('a');
    anchors.forEach((link?: HTMLAnchorElement) => {
      const hasNoVisibleText = link?.textContent?.trim() === '';
      if (hasNoVisibleText) {
        this.renderer.setAttribute(link, 'aria-hidden', 'true');
        this.renderer.setAttribute(link, 'tabindex', '-1');
      }
    });
  }
}
